import { useEffect, useMemo, useRef } from 'react';
import ActionLink from '../../../../Components/Dashboard/ActionLink';
import Card from '../../../../Components/Dashboard/Card';
import { CardEmpty, CardError, CardLoading } from '../../../../Components/Dashboard/CardState';
import { buildPastWorkouts } from './pastWorkoutsModel';
import PastWorkoutRow from './PastWorkoutRow';
import styles from '../dashboardCards.module.css';

const TITLE = 'Past workouts';

const PastWorkoutsCard = ({ workouts, now, calendarPath }) => {
    const { status, data, error, reload, markCompleted, pendingIds = [] } = workouts;
    const rows = useMemo(() => (data ? buildPastWorkouts(data, now) : null), [data, now]);

    // After "Mark completed" the button disappears: keep keyboard focus inside that row.
    const refs = useRef({});
    const clicked = useRef(null);
    useEffect(() => {
        const id = clicked.current;
        if (!id || !rows) return;
        const row = rows.find(r => r.id === id);
        if (row && !row.canComplete && refs.current[id]) {
            refs.current[id].focus();
            clicked.current = null;
        }
    }, [rows]);

    let body;
    if (status === 'loading' && !data) body = <CardLoading label={TITLE} />;
    else if (status === 'error') body = <CardError label={TITLE} status={error?.response?.status} onRetry={reload} />;
    else if (rows && rows.length === 0) body = <CardEmpty>No workouts in the last 7 days.</CardEmpty>;
    else if (rows)
        body = (
            <ul className={styles.list}>
                {rows.map(row => (
                    <PastWorkoutRow
                        key={row.id}
                        ref={el => (refs.current[row.id] = el)}
                        row={row}
                        saving={pendingIds.includes(row.id)}
                        calendarPath={calendarPath}
                        onComplete={id => {
                            clicked.current = id;
                            markCompleted(id);
                        }}
                    />
                ))}
            </ul>
        );

    return (
        <Card
            id="pw"
            module="athlete-past"
            title={TITLE}
            sub="last 7 days"
            busy={status === 'loading'}
            flush
            right={<ActionLink to={calendarPath}>View all</ActionLink>}
            foot={<span>Mark completed records the planned distance and time. To change them, open the session.</span>}
        >
            {body}
        </Card>
    );
};

export default PastWorkoutsCard;
